const columnGrid = () => {
    return <div className="container fluid my-2" id="sizes-layout">

        <div className="container fluid">
            <p className="text xl"><a href="#sizes-layout" className="link">&#128279;</a> Columns - web layout </p>
            <p className="text md">Having a mixture of sizes applied on these columns we are able
            finally to create a beautiful web layout.</p>
        </div>

        <div className="container fluid shadow-sm p-1 my-5">
            <p className="text sm left my-3">Columns from left side are defined using a specific unit number
            which will allocated a container having a certain width in the web layout, while columns on
            the right hand side are defined by <code>auto</code> class which allocates
            cols having an automatic width that forces them to fill up the remaining available
            space.
        </p>
            <div className="column gap-10">
                <div className="row primary">
                    <div className="col VI p-2">VI</div>
                </div>
                <div className="row primary">
                    <div className="col V p-2 border-light">V</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                </div>
                <div className="row primary">
                    <div className="col IV p-2 border-light">IV</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                </div>
                <div className="row primary">
                    <div className="col III p-2 border-light">III</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                </div>
                <div className="row primary">
                    <div className="col II p-2 border-light">II</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                </div>
                <div className="row primary">
                    <div className="col I p-2 border-light">I</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                </div>
                <div className="row primary">
                    <div className="col I p-2 border-light">I</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                    <div className="col auto p-2 border-light dark">auto</div>
                </div>
            </div>
        </div>

        <div className="container fluid shadow-sm p-1 my-5">
            <p className="text md">When we want to have predefined widths for the entire row of
            columns, each
            column will take a certain width in the web layout by combining them will create the grid
            system.
        </p>
            <div className="column gap-10 text-center">
                <div className="row primary">
                    <div className="col V p-2 border-light">V</div>
                    <div className="col I p-2 border-light">I</div>
                </div>
                <div className="row primary">
                    <div className="col IV p-2 border-light">IV</div>
                    <div className="col II p-2 border-light">II</div>
                </div>
                <div className="row primary">
                    <div className="col III p-2 border-light">III</div>
                    <div className="col III p-2 border-light">III</div>
                </div>
                <div className="row primary">
                    <div className="col II p-2 border-light">II</div>
                    <div className="col IV p-2 border-light">IV</div>
                </div>
                <div className="row primary">
                    <div className="col I p-2 border-light">I</div>
                    <div className="col V p-2 border-light">V</div>
                </div>
                <div className="row primary">
                    <div className="col II p-2 border-light">II</div>
                    <div className="col II p-2 border-light">II</div>
                    <div className="col II p-2 border-light">II</div>
                </div>
                <div className="row primary">
                    <div className="col I p-2 border-light">I</div>
                    <div className="col IV p-2 border-light">IV</div>
                    <div className="col I p-2 border-light">I</div>
                </div>
                <div className="row primary">
                    <div className="col I p-2 border-light">I</div>
                    <div className="col IV p-2 border-light">IV</div>
                </div>
            </div>
        </div>

    </div>
}

export default columnGrid